import DarkModeRounded from '@mui/icons-material/DarkModeRounded';
import LightModeRounded from '@mui/icons-material/LightModeRounded';
import { Box, IconButton, Tooltip, useColorScheme } from '@mui/material';

/** The console mark: a shield with a check on a green gradient tile. */
export function BrandMark({ size = 36 }: { size?: number }) {
  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        borderRadius: `${String(Math.round(size * 0.3))}px`,
        flexShrink: 0,
        display: 'grid',
        placeItems: 'center',
        color: '#fff',
        background: 'linear-gradient(135deg, #3FB394 0%, #0A6B5D 45%, #033029 100%)',
        boxShadow: '0 6px 16px -6px rgba(79,70,229,0.75), inset 0 1px 0 rgba(255,255,255,0.28)',
      }}
    >
      <svg width={size * 0.56} height={size * 0.56} viewBox="0 0 24 24" fill="none">
        <path
          d="M12 3 4.5 6v5.5c0 4.6 3.2 8 7.5 9.5 4.3-1.5 7.5-4.9 7.5-9.5V6L12 3Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
        <path
          d="m8.8 12 2.2 2.2 4.4-4.4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
}

export function ModeToggle({ sx }: { sx?: object }) {
  const { mode, systemMode, setMode } = useColorScheme();
  const dark = (mode === 'system' ? systemMode : mode) === 'dark';
  return (
    <Tooltip title={dark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        onClick={() => setMode(dark ? 'light' : 'dark')}
        aria-label="Toggle dark mode"
        sx={{ color: 'text.secondary', ...sx }}
      >
        {dark ? <LightModeRounded fontSize="small" /> : <DarkModeRounded fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
